"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHexDataLength = exports.abiEncodePacked = exports.joinHexData = void 0;
const abi_1 = require("@ethersproject/abi");
function joinHexData(hexData) {
    return `0x${hexData
        .map((hex) => {
        const stripped = hex.replace(/^0x/, '');
        return stripped.length % 2 === 0 ? stripped : '0' + stripped;
    })
        .join('')}`;
}
exports.joinHexData = joinHexData;
function abiEncodePacked(...params) {
    return joinHexData(params.map(({ type, value }) => {
        const encoded = abi_1.defaultAbiCoder.encode([type], [value]);
        if (type === 'bytes' || type === 'string') {
            const bytesLength = parseInt(encoded.slice(66, 130), 16);
            return encoded.slice(130, 130 + 2 * bytesLength);
        }
        let typeMatch = type.match(/^(?:u?int\d*|bytes\d+|address)\[\]$/);
        if (typeMatch) {
            return encoded.slice(130);
        }
        if (type.startsWith('bytes')) {
            const bytesLength = parseInt(type.slice(5));
            return encoded.slice(2, 2 + 2 * bytesLength);
        }
        typeMatch = type.match(/^u?int(\d*)$/);
        if (typeMatch) {
            if (typeMatch[1] !== '') {
                const bytesLength = parseInt(typeMatch[1]) / 8;
                return encoded.slice(-2 * bytesLength);
            }
            return encoded.slice(-64);
        }
        if (type === 'address') {
            return encoded.slice(-40);
        }
        throw new Error(`unsupported type ${type}`);
    }));
}
exports.abiEncodePacked = abiEncodePacked;
function getHexDataLength(hexData) {
    return Math.ceil((hexData.startsWith("0x") ? hexData.length - 2 : hexData.length) / 2);
}
exports.getHexDataLength = getHexDataLength;
